import React from 'react';
import StoriesListPage from './list';

const MyStoriesPage = () => <StoriesListPage notMine={false} title="My Stories" />;

export default MyStoriesPage;
